/**
 * Copyright (c) 2026, CYBRA Corp.
 */
import { Component } from '@angular/core';
import { DataMappingHeaderDto } from 'app/services/data-mapping.service';
import { ObjectService } from 'app/services/object.service';

declare const $: any;

interface ViewPropertyVM {
  propertyId: number;
  propertyName: string;
  required: boolean;
  isMapped: boolean;
  isStatic?: boolean;
  lookUp: boolean;
  valueOrColumn?: string;
}

@Component({
  selector: 'app-data-mapping-view-dialog',
  templateUrl: './data-mapping-view.dialog.component.html'
})
export class DataMappingViewDialogComponent {

  header: DataMappingHeaderDto | null = null;
  properties: ViewPropertyVM[] = [];
  isLoading = false;

  constructor(private objectService: ObjectService) {}

  /** Open popup */
  async show(header: DataMappingHeaderDto): Promise<void> {
    this.header = header;
    this.properties = [];
    this.isLoading = true;

    // Load object properties for this object type
    const props =
      await this.objectService.getPropertiesForObjectType(header.objectId);

    // Index saved mappings (includes -1 / -2)
    const mapped = new Map(
      (header.columns || []).map(c => [c.propertyId, c])
    );

    // --- Instance Name ---
    const nameMapping = mapped.get(-1);
    const nameRow: ViewPropertyVM = {
      propertyId: -1,
      propertyName: 'Name',
      required: false,
      isMapped: !!nameMapping,
      isStatic: nameMapping?.isStatic ?? false,
      lookUp: false,
      valueOrColumn: nameMapping?.valueOrColumn
    };

    // --- Instance Description ---
    const descMapping = mapped.get(-2);
    const descRow: ViewPropertyVM = {
      propertyId: -2,
      propertyName: 'Description',
      required: false,
      isMapped: !!descMapping,
      isStatic: descMapping?.isStatic ?? false,
      lookUp: false,
      valueOrColumn: descMapping?.valueOrColumn
    };

    // --- Backend object properties ---
    const propertyRows: ViewPropertyVM[] = props.map(p => {
      const mapping = mapped.get(p.id);

      return {
        propertyId: p.id,
        propertyName: p.name,
        required: true,
        isMapped: !!mapping,
        isStatic: mapping?.isStatic ?? false,
        lookUp: mapping?.lookUp ?? false,
        valueOrColumn: mapping?.valueOrColumn
      };
    });

    // Final list (Name + Description always on top)
    this.properties = [
      nameRow,
      descRow,
      ...propertyRows
    ];

    this.isLoading = false;

    $('#viewDataMappingDialog')
      .appendTo('body')
      .modal('show');
  }

  /** Close popup */
  hide(): void {
    this.header = null;
    this.properties = [];
    $('#viewDataMappingDialog').modal('hide');
  }
}
